<template>
  <div class="crpg-m-medicalConcierge-privilege">
    <div class="crpg-m-medicalConcierge-privilege__frame">
      <h3>特典</h3>
      <div class="title">{{ $t("medicalConcierge.title") }}</div>
      <table class="table" v-for="item in contentData" :key="item.lttleTitle">
        <caption>
          {{
            item.lttleTitle
          }}
        </caption>
        <tbody>
          <tr>
            <th nowrap>{{ $t("medicalConcierge.littleContent") }}</th>
            <td>
              <div v-for="(line, i) in item.littleContent" :key="i">
                {{ line }}
              </div>
            </td>
          </tr>
          <tr>
            <th nowrap>{{ $t("medicalConcierge.contentTime") }}</th>
            <td>{{ item.contentTime }}</td>
          </tr>
          <tr>
            <th nowrap>{{ $t("medicalConcierge.contentAddress") }}</th>
            <td>{{ item.contentAddress }}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    content: Array,
  },
  data() {
    return {
      contentData: this.content,
    };
  },
};
</script>
<style lang="scss" scoped>
@import "@/assets/css/molecules/medicalConcierge/privilege.scss";
</style>
